/**
 * WorkstationsVulnerabilitiesPage — seguridad del parque dentro del módulo de
 * Estaciones de trabajo.
 *
 * Arriba, el **cuadro de mando** (severidad, KEV, productos que más pesan,
 * equipos peor parados). Debajo, el panel de siempre: el detalle por producto
 * con sus CVEs y la opción de **aceptar con motivo**.
 *
 * No se duplica nada: el cuadro y el panel leen de los mismos endpoints.
 */

import React from 'react';
import VulnerabilitiesDashboard from './VulnerabilitiesDashboard';
import VulnerabilitiesPanel from './VulnerabilitiesPanel';

export default function WorkstationsVulnerabilitiesPage({ companyId }) {
  return (
    <div style={{ padding: '1.1rem 1.25rem 1.25rem', display: 'grid', gap: 16 }}>
      <VulnerabilitiesDashboard companyId={companyId} ciType="workstation" />
      <div style={{ borderTop: '1px solid var(--border)', paddingTop: 14 }}>
        <VulnerabilitiesPanel companyId={companyId} ciType="workstation" />
      </div>
    </div>
  );
}
